const getSsidDataApiCall = (siteId, headersConfigData) => {
    return fetch(
      `${
        process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetSSIDData?siteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    )
}

const setSSIDDataApiCall = (siteId, request, headersConfigData) => {
    if (headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/VisageSpa/SetSSIDData?siteId=${siteId}`,
        {
          method: "PUT",
          headers: headersConfigData(),
          body: JSON.stringify(request),
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const saveEngineSerialApiCall = (payload, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveEngineSerial?gpsiCarId=` + payload.gpsiCarId,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload.engineSerial),
    }
  );
};

export const API_CALLS = {
    getSsidDataApiCall,
    setSSIDDataApiCall,
    saveEngineSerialApiCall
};
